export const StatusEnum = {
    REQUEST: 'REQUEST' as const,
    LOADING: 'LOADING' as const,
    SUCCESS: 'SUCCESS' as const,
    FAILURE: 'FAILURE' as const,
    ERROR: 'ERROR' as const,
};